jQuery(document).ready(function ($) {
    // Leadership Modal
    $('.open-leadership-modal').magnificPopup({
        type: 'inline',
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        removalDelay: 300,
        // Class that is added to popup wrapper and background
        // make it unique to apply your CSS animations just to this exact popup
        mainClass: 'mfp-fade',
    });
});



// WEBPACK FOOTER //
// ./src/js/modals.js